/**
 * Runtime lists of API enum values (OpenAPI types exist only at compile time). Each list is checked against the
 * generated type in both directions, so a backend enum change fails the typecheck here instead of drifting.
 */
import type { AlertKind, MetricKey, PermissionKey } from './api_types';

type ExactList<Member extends string, List extends readonly Member[]> =
  Exclude<Member, List[number]> extends never ? List : { missing: Exclude<Member, List[number]> };

export function exactList<Member extends string>() {
  return <const List extends readonly Member[]>(values: ExactList<Member, List>): List => values as List;
}

/** TZ 8.1 permission keys, in the order of the settings screens. */
export const PERMISSION_KEYS = exactList<PermissionKey>()([
  'visits',
  'unique_returning',
  'children',
  'cancelled',
  'staff',
  'compare_ranking',
  'work_hours',
  'quality',
  'live',
  'export',
  'scheduled_reports_alerts',
  'api_keys',
  'store_users_manage',
  'control.view',
  'control.media',
  'control.flag',
]);

/** Every metric of `GET /metrics` (8.14). */
export const METRIC_KEYS = exactList<MetricKey>()([
  'visits',
  'unique',
  'returning',
  'children',
  'cancelled',
  'staff',
  'work_hours',
  'visits_per_hour',
  'coverage',
]);

/**
 * TZ 8.10 company alerts a client user can route to channels. The other backend alert kinds (server_offline,
 * release_failed, scheduled_task_failed...) are super-admin notifications (section 10) and never reach the panel.
 */
export const ALERT_KINDS = [
  'flow_drop',
  'late_open',
  'early_close',
  'camera_offline',
  'no_data',
  'record',
  'cancelled_spike',
  'target_progress',
] as const satisfies readonly AlertKind[];

export type CompanyAlertKind = (typeof ALERT_KINDS)[number];
